import React from 'react';
import { Card } from './ui/Card';
import { Users, TrendingUp, Calendar, Database } from 'lucide-react';
const stats = [{
  icon: Users,
  value: '1,200+',
  label: 'Sales Professionals Served',
  color: 'text-blue-500'
}, {
  icon: TrendingUp,
  value: '$7M+',
  label: 'Additional Revenue Generated',
  color: 'text-green-500'
}, {
  icon: Calendar,
  value: '4.5',
  label: 'Years CRM Focus',
  color: 'text-orange-500'
}, {
  icon: Database,
  value: '110+',
  label: 'CRM Systems Built',
  color: 'text-purple-500'
}];
export function StatsBar() {
  return <section className="py-12 bg-[#0A0E27]" data-id="element-162" data-mp="15lyuswtbcizs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163" data-mp="15ijejqnwl3ws">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-164" data-mp="10n412ztt5a0w">
          {stats.map((stat, index) => <Card key={index} className="p-6 flex items-center space-x-4 hover:border-[#334155] transition-colors" data-id="element-165" data-mp="vou7uurn8jhx" data-mpi={index}>
              <div className={`p-3 rounded-lg bg-[#1E293B] ${stat.color}`} data-id="element-166" data-mp="3onu8gpy4dncq">
                <stat.icon className="w-6 h-6" data-id="element-167" data-mp="3tekd20yq1m6d" />
              </div>
              <div data-id="element-168" data-mp="3tgx2t0aq10tz">
                <div className="text-2xl font-bold text-white" data-id="element-169" data-mp="3epxtfn22a89c">
                  {stat.value}
                </div>
                <div className="text-sm text-[#94A3B8]" data-id="element-170" data-mp="3johku2zfcc93">{stat.label}</div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}